window.BOLD = window.BOLD || {}
BOLD.BMS = BOLD.BMS || {}
BOLD.BMS.CartMotivator = BOLD.BMS.CartMotivator || {}

Handlebars.registerHelper('lte', function (num, target) {
  return num <= target
})

Handlebars.registerHelper('formatMoney', function (cents) {
  return Shopify.formatMoney(cents, Shopify.money_format)
})

BOLD.BMS.CartMotivator = (function ($) {
  var compiledTemplate
  var settings
  var $widgetContainers

  /**
   * Updates the motivator widget with the delta until the customer
   * will get free shipping
   * 
   * @param {Cart} cart 
   */
  function updateMotivatorWidget (cart) {
    if (!settings.motivator_enabled) return // Preventing if disabled

    var delta = Math.round(settings.motivator_threshold * 100) - cart.total_price
    var html = compiledTemplate({
      delta: delta
    })

    $widgetContainers.html(html)
  }

  function init (cart, s, template) {

    // Setting module variables
    compiledTemplate = Handlebars.compile(template)
    settings = s
    $widgetContainers = $('.cart-motivator-container')

    updateMotivatorWidget(cart)
  }

  return {
    init: init,
    updateMotivatorWidget: updateMotivatorWidget
  }
})(BOLD.jQuery || jQuery)
